<template>
  <div>
    <b-navbar
      v-if="!appHeaderHidden"
      toggleable="lg"
    >
      <b-navbar-brand href="#">
        <img
          class="img-logo"
          :src="logo"
          @click="goToHomePage"
        >
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" />

      <b-collapse
        id="nav-collapse"
        is-nav
      >
        <b-navbar-nav class="center">
          <b-nav-item :active="isActive('licenses')">
            <router-link
              v-if="isAuthenticated"
              class="nav-link"
              to="/licenses"
            >
              Lizenzen
            </router-link>
          </b-nav-item>
          <b-nav-item :active="isActive('companies')">
            <router-link
              v-if="isAuthenticated"
              class="nav-link"
              to="/companies"
            >
              Kunden
            </router-link>
          </b-nav-item>
          <b-nav-item :active="isActive('users')">
            <router-link
              v-if="isAdmin"
              class="nav-link"
              to="/users"
            >
              Benutzer
            </router-link>
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="right">
          <b-nav-item>
            <router-link
              v-if="!isAuthenticated"
              class="nav-link sign-in-link"
              to="/sign-in"
            >
              Anmelden
            </router-link>
          </b-nav-item>
          <b-nav-item
            v-if="isAuthenticated"
            class="nav-link sign-out-link"
            @click="signOut"
          >
            Ausloggen
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import {AuthMixin} from '../../mixins';
import logo from '../../assets/R.svg';

export default {
  name: 'AppHeader',
  mixins: [AuthMixin],
  props: {
    appName: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      logo: logo
    };
  },
  computed: {
    appHeaderHidden() {return this.$route.meta.appHeaderHidden;}
  },
  methods: {
    isActive(routeName) {
      return this.$route.name === routeName || this.$route.meta.parentRoute === routeName;
    }
  }
};
</script>

<style scoped lang="scss">
  .img-logo {
    height: 30px;
  }

  .sign-out-link, .sign-in-link {
    text-decoration-line: underline;
  }
</style>
